module.exports = __webpack_public_path__ + "static/media/DW_Logo.bb6f22bc.png";